<template>
  <div id="app" class="bg-white">
    <div>
      <section :class="animation">
        <div class="input-fields">
          <BookerCreation :referrer_id="referrer_id"  />
        </div>
      </section>
    </div>
  </div>
</template>


<script>
import BookerCreation from "@/components/BDR/BookerCreation.vue";
export default {
  data(){
    return{
      option:'',
      referrer_id: null,
    }
  },
  computed: {
    user() {
      return this.$store.state.authentication.user;
    }
  },
  components: {
    BookerCreation,
  },
  created() {
    if(this.isValueInt(this.$route.params.referrer_id)){      
      this.referrer_id = this.$route.params.referrer_id ? this.$route.params.referrer_id : null;
    }    
  },
  methods: {
    isValueInt(value) {
      return /^\d+$/.test(value);
    }
  }

}
</script>
